import { Component } from '@angular/core';
import Swiper from "swiper";
import { EffectFade, Navigation, Pagination, Autoplay } from "swiper/modules";
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-tab-content1',
    imports: [CommonModule, NgOptimizedImage],
    templateUrl: './tab-content1.component.html',
    styleUrl: './tab-content1.component.scss'
})
export class TabContent1Component {
    assetsCDNUrl = environment.assetsCDNUrl;
    activeTabIndex: number = 0; // The index of the active tab

    ngAfterViewInit() {
        if (typeof window != "undefined") {
            setTimeout(() => {
                this.loadSlider();
            }, 500);
        }
    }

    // Load Slider
    loadSlider() {
        if (window.innerWidth < 992) {
            new Swiper("#map-slider", {
                modules: [Navigation, Pagination, EffectFade, Autoplay],
                autoplay: false,
                loop: false,
                slidesPerView: 3.5,
                spaceBetween: 10,
                pagination: {
                    clickable: true,
                    el: ".swiper-map-pagination",
                },
                breakpoints: {
                    480: {
                        slidesPerView: 3.5,
                    },
                    768: {
                        slidesPerView: 5.5,
                    },
                },
            });
        }
    }

    selectTab(index: number): void {
        this.activeTabIndex = index;
    }

    data = {
        heading: "Supporting You, <u>Across India</u>",
        description: "<p>Operating nationwide to provide seamless wealth solutions.</p>",

        items: [
            {
                title: 'Mumbai',
                tabIcon: '/assets/images/locations/mumbai.svg',
                description: '<p>The Capital, A wing, 1st Floor, Unit No. 110, G Block, Bandra Kurla Complex, Bandra (East), Mumbai – 400 051</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/mumbai.webp',
                cardIcon: '/assets/images/locations/mumbai-bw.svg'
            },
            {
                title: 'Delhi',
                tabIcon: '/assets/images/locations/delhi.svg',
                description: '<p> Shriram Wealth, 409, Southern Park, Saket district centre, Saket, New Delhi </p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/delhi.webp',
                cardIcon: '/assets/images/locations/delhi-bw.svg'
            },
            {
                title: 'Gurugram',
                tabIcon: '/assets/images/locations/gurugram.svg',
                description: '<p>Seva corporate park, Unit no 201A, M.G road, DLF phase 2, sector 25, Gurugram, Haryana – 122002</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/gurugram.webp',
                cardIcon: '/assets/images/locations/gurugram-bw.svg'
            },
            {
                title: 'Bengaluru',
                tabIcon: '/assets/images/locations/bengaluru.svg',
                description: '<p>2nd Floor, TS Towers, Coffee Day Square, Vittal Mallya Rd, near Cubbon Park, Bengaluru 560001.</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/bengaluru.webp',
                cardIcon: '/assets/images/locations/bengaluru-bw.svg'
            },
            {
                title: 'Hyderabad',
                tabIcon: '/assets/images/locations/hyderabad.svg',
                description: '<p>Shriram Wealth Ltd, 11th Floor, Rajapushpa Summit, Nanakramguda Village, Serillingapally mandal, Rangareddy District, Financial District, Hyderabad, Telangana Pin: 500032</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/hyderabad.webp',
                cardIcon: '/assets/images/locations/hyderabad-bw.svg'
            },
            {
                title: 'Chennai',
                tabIcon: '/assets/images/locations/chennai.svg',
                description: '<p>Shriram Wealth Ltd, 1st Floor, No. 221, Royapettah High Road, Luz, Mylapore, Chennai, Tamilnadu Pin: 600004</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/chennai.webp',
                cardIcon: '/assets/images/locations/chennai-bw.svg'
            },
            {
                title: 'Kolkata',
                tabIcon: '/assets/images/locations/kolkata.svg',
                description: '<p>Shriram Wealth Ltd, 2nd floor, J B House, 2. Upper Wood Street, Kolkata: WB Pin: 700016</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/kolkata.webp',
                cardIcon: '/assets/images/locations/kolkata-bw.svg'
            },

            {
                title: 'Ahmedabad',
                tabIcon: '/assets/images/locations/ahmedabad.svg',
                description: '<p>C-808, The First, Beside ITC Narmada, Keshav Baug, Satellite, Ahmedabad</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/ahmedabad.webp',
                cardIcon: '/assets/images/locations/ahmedabad-bw.svg'
            },
            {
                title: 'Pune',
                tabIcon: '/assets/images/locations/pune.svg',
                description: '<p>Park Plaza, 9th floor Ganeshkhind Rd, Akashvani Rashtriya Film Sangrahalay Quarters, Model Colony, Shivajinagar, Pune, Maharashtra 411016</p> <p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/pune.webp',
                cardIcon: '/assets/images/locations/pune-bw.svg'
            },
        ]
    }

}
